import React from 'react';
import {BrowserRouter as Router, Switch, Route, Link} from 'react-router-dom';
import {HomeScreen} from '../screens';
import {Client as Styletron} from 'styletron-engine-atomic';
import {Provider as StyletronProvider} from 'styletron-react';
import {
  ThemeProvider,
  BaseProvider,
  createTheme,
  lightThemePrimitives,
} from 'baseui';

import {Provider} from 'react-redux';
import {store} from '../store';

const engine = new Styletron();

export default function App() {
  return (
    <Provider store={store}>
      <StyletronProvider value={engine}>
        <BaseProvider
          theme={createTheme(lightThemePrimitives, {
            colors: {
              buttonPrimaryFill: '#0775EB',
              buttonPrimaryHover: '#228DFF',
              buttonPrimaryActive: '#0775EB',
            },
          })}>
          <Router>
            <Switch>
              <Route path="/">
                <HomeScreen />
              </Route>
            </Switch>
          </Router>
        </BaseProvider>
      </StyletronProvider>
    </Provider>
  );
}
